import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import ReactCursorPosition, { INTERACTIONS } from 'react-cursor-position';
import { CalendarWrap, CalendarHeader, CalendarMonthWrap, CalendarDayWrap, CalendarDay, CalendarDayInner, CalendarDayContent, CalendarHeaderChevron, CalendarHeaderTitle, CalendarDayDetailWrap, CalendarDayDetailTimeline, CalendarDayDetailHeader, CalendarDayDetailHourWrap, CalendarTimeWrap, CalendarTimeLine, CalendarTimeBall, CalendarDetailTimelineWrap, CalendarTimelineTimeLabel, CalendarDayEventDot, CalendarTimelineEvent } from './styled';
export var Calendar = /*#__PURE__*/function (_React$Component) {
  _inherits(Calendar, _React$Component);

  var _super = _createSuper(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, props);
    _this.state = {
      drillDownDate: null,
      timeMinute: moment(props.selectedDate).hours() * 60 + moment(props.selectedDate).minutes(),
      transitionView: false
    };

    _this.monthDays = function () {
      var map = {};
      var monthMoment = moment(props.displayedDate);
      var seedMonthCount = 12;

      for (var i = 0; i < seedMonthCount; i++) {
        var monthDays = [];
        var thisMonth = monthMoment.clone().add(i < seedMonthCount / 2 ? -i : i - seedMonthCount / 2, 'month');
        var monthKey = "".concat(thisMonth.clone().startOf('day').valueOf());
        var current = thisMonth.clone().startOf('month').startOf('day');

        if (current.day() !== 0) {
          while (current.day() !== 0) {
            current.subtract(1, 'day');
          }
        }

        while (current.isBefore(thisMonth.clone().endOf('month'))) {
          monthDays.push(current.clone());
          current.add(1, 'day');
        }

        if (current.day() !== 0) {
          while (current.day() !== 0) {
            monthDays.push(current.clone());
            current.add(1, 'day');
          }
        }

        map[monthKey] = monthDays;
      }

      return map;
    }();

    return _this;
  }

  _createClass(Calendar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          selectedDate = _this$props.selectedDate,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          dayClassName = _this$props.dayClassName,
          dayOfWeekClassName = _this$props.dayOfWeekClassName,
          displayedDate = _this$props.displayedDate,
          onRequestDecrementMonth = _this$props.onRequestDecrementMonth,
          onRequestIncrementMonth = _this$props.onRequestIncrementMonth,
          onClick = _this$props.onClick,
          eventsOnDay = _this$props.eventsOnDay,
          eventDotColor = _this$props.eventDotColor,
          drillDownEnabled = _this$props.drillDownEnabled,
          loadingPosts = _this$props.loadingPosts;
      var selectedMoment = moment(selectedDate);
      var monthMoment = moment(displayedDate);
      return !this.state.drillDownDate ? /*#__PURE__*/React.createElement(CalendarWrap, {
        style: {
          opacity: !this.state.transitionView ? 1 : 0
        }
      }, /*#__PURE__*/React.createElement(CalendarHeader, null, /*#__PURE__*/React.createElement(CalendarHeaderTitle, null, /*#__PURE__*/React.createElement("strong", null, monthMoment.format('MMMM')), "\xA0", /*#__PURE__*/React.createElement("span", null, monthMoment.format('YYYY'))), /*#__PURE__*/React.createElement("span", null, loadingPosts), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CalendarHeaderChevron, {
        onClick: function onClick() {
          return onRequestDecrementMonth(monthMoment.clone().toDate());
        }
      }, "\u2039"), /*#__PURE__*/React.createElement(CalendarHeaderChevron, {
        style: {
          marginLeft: 20
        },
        onClick: function onClick() {
          return onRequestIncrementMonth(monthMoment.clone().toDate());
        }
      }, "\u203A"))), /*#__PURE__*/React.createElement(CalendarMonthWrap, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", null, ['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(function (str, idx) {
        return /*#__PURE__*/React.createElement(CalendarDay, {
          key: "dayofweek_".concat(idx)
        }, /*#__PURE__*/React.createElement(CalendarDayInner, null, /*#__PURE__*/React.createElement(CalendarDayContent, {
          className: classnames({
            header: true
          }, dayOfWeekClassName)
        }, str)));
      })), /*#__PURE__*/React.createElement("div", null, _toConsumableArray(new Array(3)).map(function (_, monthFrameIndex) {
        var monthDays = [];
        var thisMonth = monthMoment.clone().add(monthFrameIndex === 0 ? -1 : monthFrameIndex === 1 ? 0 : 1, 'month');
        var monthKey = "".concat(thisMonth.clone().startOf('day').valueOf());

        if (!_this2.monthDays[monthKey]) {
          var current = thisMonth.clone().startOf('month').startOf('day');

          if (current.day() !== 0) {
            while (current.day() !== 0) {
              current.subtract(1, 'day');
            }
          }

          while (current.isBefore(thisMonth.clone().endOf('month'))) {
            monthDays.push(current.clone());
            current.add(1, 'day');
          }

          if (current.day() !== 0) {
            while (current.day() !== 0) {
              monthDays.push(current.clone());
              current.add(1, 'day');
            }
          }

          _this2.monthDays[monthKey] = monthDays;
        } else {
          monthDays = _this2.monthDays[monthKey];
        }

        return /*#__PURE__*/React.createElement(CalendarDayWrap, {
          key: "".concat(thisMonth.month()).concat(thisMonth.year()),
          style: {
            transform: monthFrameIndex < Math.round((3 - 1) / 2) ? 'translateX(-100%)' : monthFrameIndex > Math.round((3 - 1) / 2) ? 'translateX(100%)' : 'translateX(0)'
          }
        }, monthDays.map(function (day, idx) {
          var disabled = !!minDate && day.isBefore(moment(minDate), 'day') || !!maxDate && day.isAfter(moment(maxDate), 'day');
          var isToday = day.isSame(moment(), 'day');
          var isOutsideMonth = day.isBefore(thisMonth.clone().startOf('month').startOf('day')) || day.isAfter(thisMonth.clone().endOf('month').endOf('day'));
          var isSelected = day.isSame(selectedMoment, 'day');
          var dayEvents = monthFrameIndex === 1 && !_this2.state.transitionView ? eventsOnDay(day.toDate()) : [];
          return /*#__PURE__*/React.createElement(CalendarDay, {
            className: classnames({
              today: isToday,
              outsideMonth: isOutsideMonth,
              selected: isSelected
            }, dayClassName),
            key: "".concat(thisMonth.month()).concat(thisMonth.year(), "-").concat(day.unix()),
            onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var date;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!day.isBefore(moment(), 'day')) {
                        _context.next = 2;
                        break;
                      }

                      return _context.abrupt("return", false);

                    case 2:
                      date = day.clone().minutes(_this2.state.timeMinute).toDate();
                      !disabled && onClick(date);

                      if (!drillDownEnabled) {
                        _context.next = 12;
                        break;
                      }

                      _this2.setState({
                        transitionView: true
                      });

                      _context.next = 8;
                      return new Promise(function (resolve) {
                        setTimeout(resolve, 300);
                      });

                    case 8:
                      _this2.setState({
                        drillDownDate: date,
                        transitionView: false
                      });

                      _context.next = 11;
                      return new Promise(function (resolve) {
                        setTimeout(resolve, 300);
                      });

                    case 11:
                      _this2.setState({
                        transitionView: true
                      });

                    case 12:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))
          }, /*#__PURE__*/React.createElement(CalendarDayInner, null, /*#__PURE__*/React.createElement(CalendarDayContent, {
            className: classnames({
              disabled: disabled,
              today: isToday
            })
          }, day.format('D'))), dayEvents && dayEvents.length > 0 && /*#__PURE__*/React.createElement(CalendarDayEventDot, null, /*#__PURE__*/React.createElement("div", {
            style: {
              background: eventDotColor
            }
          })));
        }));
      }))))) : function () {
        var dayEvents = eventsOnDay(_this2.state.drillDownDate);
        return /*#__PURE__*/React.createElement(CalendarDayDetailWrap, {
          style: {
            opacity: !_this2.state.transitionView ? 0 : 1
          }
        }, /*#__PURE__*/React.createElement(CalendarDayDetailHeader, null, /*#__PURE__*/React.createElement(CalendarHeaderChevron, {
          onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this2.setState({
                      transitionView: false
                    });

                    _context2.next = 3;
                    return new Promise(function (resolve) {
                      setTimeout(resolve, 300);
                    });

                  case 3:
                    _this2.setState({
                      drillDownDate: null,
                      transitionView: true
                    });

                    _context2.next = 6;
                    return new Promise(function (resolve) {
                      setTimeout(resolve, 300);
                    });

                  case 6:
                    _this2.setState({
                      transitionView: false
                    });

                  case 7:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }))
        }, "\u2039"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
          style: {
            color: 'black',
            fontSize: 20,
            fontWeight: 'bold',
            margin: 0
          }
        }, moment(_this2.state.drillDownDate).format('dddd[, ]MMMM[ ]Do[, ]YYYY')), /*#__PURE__*/React.createElement("p", {
          style: {
            color: 'black',
            marginBottom: 0
          }
        }, moment(_this2.state.drillDownDate).startOf('day').add(_this2.state.timeMinute, 'minute').format('h:mm A')))), /*#__PURE__*/React.createElement(ReactCursorPosition, {
          onActivationChanged: function onActivationChanged(_ref3) {
            var isActive = _ref3.isActive;

            if (!isActive) {
              var m = moment(_this2.state.drillDownDate).startOf('day').add(_this2.state.timeMinute, 'minute');
              m.set('seconds', 0);
              onClick(m.toDate());
            }
          },
          shouldDecorateChildren: false,
          activationInteractionMouse: INTERACTIONS.CLICK,
          onPositionChanged: function onPositionChanged(_ref4) {
            var isActive = _ref4.isActive,
                yPos = _ref4.position.y;

            if (isActive) {
              var wrapEl = document.getElementById('calendar-timeline-container');
              var absY = wrapEl.scrollTop + yPos;
              var mins = parseFloat(absY) / 44.0 * 60.0;

              _this2.setState({
                timeMinute: mins
              }, function () {
                var m = moment(_this2.state.drillDownDate).startOf('day').add(_this2.state.timeMinute, 'minute');
                m.set('seconds', 0);
                onClick(m.toDate());
              });
            }
          }
        }, /*#__PURE__*/React.createElement(CalendarDetailTimelineWrap, {
          id: "calendar-timeline-container"
        }, /*#__PURE__*/React.createElement(CalendarTimeWrap, null, function () {
          var top = _this2.state.timeMinute / 60.0 * 44.0;
          return [/*#__PURE__*/React.createElement(CalendarTimelineTimeLabel, {
            key: "calendar-timestring",
            style: {
              top: top - 22
            }
          }, moment(_this2.state.drillDownDate).startOf('day').add(_this2.state.timeMinute, 'minute').format('h:mm A')), /*#__PURE__*/React.createElement(CalendarTimeLine, {
            key: "calendar-line",
            style: {
              top: top
            }
          }), /*#__PURE__*/React.createElement(CalendarTimeBall, {
            key: "calendar-ball",
            style: {
              top: top
            }
          })];
        }(), dayEvents.map(function (event) {
          return /*#__PURE__*/React.createElement(CalendarTimelineEvent, {
            style: {
              top: moment(event.startTime).diff(moment(_this2.state.drillDownDate).startOf('day'), 'minutes') / 60.0 * 44.0,
              height: moment(event.startTime).diff(moment(event.endTime), 'minutes') / 60.0 * 44.0,
              background: event.backgroundColor || 'rgb(126, 126, 126)',
              color: event.textColor || 'white'
            },
            key: event.key
          }, event.title);
        })), /*#__PURE__*/React.createElement(CalendarDayDetailHourWrap, null, _toConsumableArray(new Array(24)).map(function (_, idx) {
          return /*#__PURE__*/React.createElement("div", {
            key: idx
          }, /*#__PURE__*/React.createElement("span", null, idx > 0 && idx < 24 && moment().startOf('day').add(idx, 'hours').format('h A')));
        })), /*#__PURE__*/React.createElement(CalendarDayDetailTimeline, null, _toConsumableArray(new Array(24)).map(function (_, idx) {
          return /*#__PURE__*/React.createElement("section", {
            key: idx
          }, /*#__PURE__*/React.createElement("div", null));
        })))));
      }();
    }
  }]);

  return Calendar;
}(React.Component);

_defineProperty(Calendar, "defaultProps", {
  displayedDate: moment(),
  onRequestDecrementMonth: function onRequestDecrementMonth() {},
  onRequestIncrementMonth: function onRequestIncrementMonth() {},
  onClick: function onClick() {},
  eventsOnDay: function eventsOnDay() {
    return [];
  },
  eventDotColor: '#ea4335',
  drillDownEnabled: true
});

export default function DatePicker(_ref5) {
  var open = _ref5.open,
      selectedDate = _ref5.selectedDate,
      displayedDate = _ref5.displayedDate,
      minDate = _ref5.minDate,
      maxDate = _ref5.maxDate,
      onRequestClose = _ref5.onRequestClose,
      onRequestIncrementMonth = _ref5.onRequestIncrementMonth,
      onRequestDecrementMonth = _ref5.onRequestDecrementMonth,
      onDateSelected = _ref5.onDateSelected,
      eventsOnDay = _ref5.eventsOnDay,
      drillDownEnabled = _ref5.drillDownEnabled,
      children = _ref5.children,
      style = _ref5.style,
      className = _ref5.className,
      loadingPosts = _ref5.loadingPosts;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: className
  }, children, /*#__PURE__*/React.createElement(Calendar, {
    loadingPosts: loadingPosts,
    selectedDate: selectedDate,
    minDate: minDate,
    maxDate: maxDate,
    displayedDate: displayedDate,
    onRequestIncrementMonth: onRequestIncrementMonth,
    onRequestDecrementMonth: onRequestDecrementMonth,
    onClick: onDateSelected,
    eventsOnDay: eventsOnDay,
    drillDownEnabled: drillDownEnabled
  }));
}